import { useRef } from 'react';
type FuncType = (...args: any[]) => void;
type PromiseFunc = (...args: any[]) => Promise<void>;
export default function useDebounce(func: FuncType | PromiseFunc, delay: number) {
  const ref = useRef<NodeJS.Timer | null>(null);

  return (...args: any[]) => {
    clearTimeout(ref.current!);
    ref.current = setTimeout(() => func(...args), delay);
  };
}
